// extracted by mini-css-extract-plugin
module.exports = {"component":"App_component__3J_JI","content":"App_content__1Wt3K","subHeader":"App_subHeader__3w2wQ"};